import React from 'react';
import { SUPPORTED_LANGS } from '../../config/i18n/i18n';
import styles from './LanguageSelector.module.css';

const LANG_LABELS: Record<string, string> = {
    fr: '🇫🇷 Français',
    en: '🇬🇧 English',
    nl: '🇳🇱 Nederlands',
};

interface LanguageSelectorProps {
    value: string;
    onChange: (lang: string) => void;
}

const LanguageSelector: React.FC<LanguageSelectorProps> = ({ value, onChange }) => (
    <div className={styles.langButtons}>
        {SUPPORTED_LANGS.map((lang) => (
            <button
                key={lang}
                type="button"
                className={`${styles.langBtn} ${value === lang ? styles.langBtnActive : ''}`}
                onClick={() => onChange(lang)}
            >
                {LANG_LABELS[lang] ?? lang}
            </button>
        ))}
    </div>
);

export default LanguageSelector;
